import { Component, Input, AfterViewInit, ElementRef, OnDestroy } from '@angular/core';
import { DomStorageFallbackService } from '../../services/DomStorageFallback.service';

@Component({
    selector: 'al-loading-indicator',
    template: `
        <div id="{{id}}" [style.display]="initialShow ? 'block' : 'none'" class="loading-indicator-container" aria-live="polite"  role="alert" aria-busy="false">
            <div *ngIf="loadingType !== 'fieldLevel'" class="loading-indicator" [style.paddingTop]="loadingText || loadingMessages.length > 0 ? '45px' : ''">{{loadingText}}</div>
            <div *ngIf="loadingType === 'fieldLevel'" class="loading-indicator-fieldLevel">{{loadingText}}</div>
        </div>
      `,
    providers: [DomStorageFallbackService]
})
export class AlLoaderComponent implements AfterViewInit, OnDestroy {

    public relaySpinnerTimer;

    // setting ID for loading instance
    @Input() id: string;

    // Checking initial state should visible or not
    @Input() initialShow: boolean;

    // set a Message for loader
    @Input() loadingText: string;

    // set type of loader, default is module
    @Input() loadingType: string = 'moduleLevel';

    // Only loading icon only, default is false
    @Input() loadingIconOnly: boolean = false;

    public loadingMessages: any[] = ['Hold on ...', 'Loading ...', 'Getting there ...', 'Almost done!'];

    /**
     * @constructs
     * Seting constructor method and required param
     *
     * @param _element
     *
     */
    constructor(private _element: ElementRef, private domStorageFB: DomStorageFallbackService) {

    }

    /**
     * Show indicator using ID
     *
     * @method showIndicator
     * @param elemId
     * @param targetId
     *
     */
    showIndicator(elemId, targetId) {
        if (document.querySelector(elemId)) {
            document.querySelector(elemId).children[0].style.display = 'block';
            document.querySelector(elemId).children[0].setAttribute('aria-busy', true);
        }
        if (targetId) {
            document.querySelector(elemId).children[0].style.display = 'none';
            if (this._element.nativeElement.querySelector('.loading-indicator-fieldLevel')) {
                document.querySelector(targetId).appendChild(this._element.nativeElement.querySelector('.loading-indicator-fieldLevel'));
            }
        }

        if (!targetId) {
            if (this.loadingMessages && this.loadingMessages.length > 0) {
                this.updateLoadingMessages(elemId);
            }
        }
    }

    /**
     * Hide indicator using ID
     *
     * @method hideIndicator
     * @param elemId
     * @param targetId
     *
     */
    hideIndicator(elemId, targetId) {
        if (document.querySelector(elemId)) {
            document.querySelector(elemId).children[0].style.display = 'none';
            document.querySelector(elemId).children[0].setAttribute('aria-busy', false);
        }

        let relaySpinnerTimerId = document.querySelector(elemId).children[0].getAttribute('data-timer-id');
        this.clearLoadingSpinnerTimer(relaySpinnerTimerId);
    }

    /**
     *
     * @method updateLoadingMessages : Update or change loading indicator messages on specific time interval
     * @param elementId id of selected element
     *
     */
    public updateLoadingMessages(elementId) {
        let iSecond = 0, loadingMessages, loadingIndicatorElement;

        const elementCheck = elementId.toString();
        if (elementCheck.indexOf('#') === 0) {
            loadingIndicatorElement = document.querySelector(elementId + '.loading-indicator') || document.querySelector(elementId + ' .loading-indicator');
        } else {
            loadingIndicatorElement = elementId.querySelector('.loading-indicator');
        }

        let loaderValueFromStorage = this.domStorageFB.getItem('loaderValue', 'localStorage', true);
        if (loaderValueFromStorage) {
            let updatedLoaderValue = loaderValueFromStorage.split(',');
            if (updatedLoaderValue.length > 0) {
                loadingMessages = updatedLoaderValue;
            }
        } else {
            loadingMessages = this.loadingMessages;
        }

        if (loadingIndicatorElement) {
            loadingIndicatorElement.innerHTML = loadingMessages[0] || this.loadingText;

            /* istanbul ignore next */
            this.relaySpinnerTimer = setInterval(() => {
                iSecond += 1;
                if (iSecond > 0 && iSecond <= 1) {

                } else if (iSecond > 1 && iSecond <= 9) {

                    if (iSecond <= 2) {
                        //
                    }

                } else if (iSecond > 9 && iSecond <= 19) {
                    if (loadingMessages[1]) {
                        loadingIndicatorElement.innerHTML = loadingMessages[1] || this.loadingText;
                    }
                } else if (iSecond > 19 && iSecond <= 29) {
                    if (loadingMessages[2]) {
                        loadingIndicatorElement.innerHTML = loadingMessages[2] || this.loadingText;
                    }
                } else if (iSecond > 29 && iSecond <= 38) {
                    if (loadingMessages[3]) {
                        loadingIndicatorElement.innerHTML = loadingMessages[3] || this.loadingText;
                    }
                } else {
                    let relaySpinnerTimerId = loadingIndicatorElement.parentElement.getAttribute('data-timer-id');
                    this.clearLoadingSpinnerTimer(relaySpinnerTimerId);
                }

            }, 1000);

            loadingIndicatorElement.parentElement.setAttribute('data-timer-id', this.relaySpinnerTimer);
        }
    }

    public _window(): any {
        // return the native window obj
        return window;
    }

    clearLoadingSpinnerTimer(timerId) {
        if (timerId) {
            clearInterval(timerId);
        }
    }

    /**
     * Initializing loading component once its view is available
     *
     * @event ngAfterViewInit
     *
     */
    ngAfterViewInit() {
        if (this.loadingType === 'pageLevel') {
            document.querySelector('body').appendChild((this._element.nativeElement as HTMLElement));
            this._element.nativeElement.children[0].classList.add('onbody');
        }

        // Update loading indicator messages on page load when initialShow is true
        setTimeout(() => {
            if (this.initialShow) {
                if (this._element.nativeElement) {
                    let elemId = this._element.nativeElement;

                    if (!this.loadingIconOnly && !this.loadingText) {
                        if (this.loadingMessages && this.loadingMessages.length > 0) {
                            this.updateLoadingMessages(elemId);
                        }
                    }
                }
            }
        }, 100);
    }

    ngOnDestroy() {
        if (this._element.nativeElement) {
            if (this._element.nativeElement.hasOwnProperty('remove')) {
                this._element.nativeElement.remove();
            } else {
                if (this._element.nativeElement.parentNode) {
                    this._element.nativeElement.parentNode.removeChild(this._element.nativeElement);
                }
            }
        }
    }

}
